import React, { useState, useEffect } from 'react';
import {Container, Card, Row, Col}  from 'react-bootstrap';
import { BsXSquareFill } from "react-icons/bs";

function SystemMessage( { message, closeMessage } ) {
    const [systemMessage, setSystemMessage] = useState("");

    useEffect(() => {
        if (typeof message !== 'undefined') {
            setSystemMessage(message);
        }
        
    }, [message]);

    const dismissMessage = ( () => {
        closeMessage();
    });
    
    return(
      <Container>
        <Row className="justify-content-md-center">
          <Col>
            <Card className={'mb-1 mt-2 card-system-message'}>
              <Card.Body className={' content-container'}>
                <div className="left-content d-flex align-items-center flex-grow-1">{systemMessage}</div>
                <div className="right-content"><BsXSquareFill onClick={dismissMessage}/></div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>);
}

export default SystemMessage;
